var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileea4F1C2E({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7657",
    "data-name": "Rectangle 7657",
    width: 50,
    height: 50,
    rx: 10,
    transform: "translate(1770 60)",
    fill: "#4eb969",
    opacity: 0.7
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "profile_icon",
    "data-name": "profile icon",
    transform: "translate(-1770 -60)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2547",
    "data-name": "Path 2547",
    d: "M32.6,38.9A24.577,24.577,0,0,1,0,38.9a7.722,7.722,0,0,1,2.048-2.063,43.449,43.449,0,0,1,6.018-3.63,6.164,6.164,0,0,0,3.516-5.91,1.264,1.264,0,0,0-.551-1.092A18.585,18.585,0,0,1,8.972,24.4c-1.425-1.489-2.643-3.1-2.394-5.386-1.267-.073-2.167-.6-2.327-1.927-.142-1.182.274-1.822,1.536-2.45-.144-.421-.284-.856-.442-1.285A10.918,10.918,0,0,1,4.5,9.37,8.256,8.256,0,0,1,8.119,2.382,12.641,12.641,0,0,1,15.186,0,9.564,9.564,0,0,1,23.271,3.94a.837.837,0,0,0,.572.3,3.04,3.04,0,0,1,3.445,3.021,17.124,17.124,0,0,1-.631,6.242,5.92,5.92,0,0,0-.15.656.424.424,0,0,0,.351.525,2.027,2.027,0,0,1,1.518,2.268,2.068,2.068,0,0,1-1.838,1.981c-.155.026-.311.046-.458.068a11.762,11.762,0,0,1-.117,1.549,7.706,7.706,0,0,1-2.285,3.786,22.721,22.721,0,0,1-2.166,1.912,1.156,1.156,0,0,0-.493.971,6.089,6.089,0,0,0,3.405,5.92A45.617,45.617,0,0,1,30.646,36.9a7.539,7.539,0,0,1,1.954,2",
    transform: "translate(1778.7 71.001)",
    fill: "rgba(5,26,53,0.7)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileea4F1C2E);
export default __webpack_public_path__ + "static/media/profile.ea4f1c2e.9a8e9cedda867d5287af63760013f308.svg";
export { ForwardRef as ReactComponent };